angular
    .module('empower.modules')
    .constant('notificationContextEnum', {
        ALL: 1,
        NATIONAL: 2,
        NSI: 3
    });